import { Component, Output, Input, EventEmitter } from '@angular/core';

import { DvlSettingsService } from '../../../services/settings.service';

@Component({
  selector: 'dvl-alerts-dialog',
  templateUrl: './alerts-dialog.component.html'
})
export class DvlAlertsDialogComponent {
  @Output('close') closeEmitter: EventEmitter<void>;
  @Output('read') readEmitter: EventEmitter<void>;
  @Input() alerts: any[];

  private foods: any[];

  constructor(private settingsService: DvlSettingsService) {
    this.closeEmitter = new EventEmitter<void>();
    this.readEmitter = new EventEmitter<void>();
    this.alerts = [];
    this.foods = [];

    this.settingsService.foods$.subscribe((foods) => this.foods = foods);
  }

  close(): void {
    this.closeEmitter.emit();
  }

  read(): void {
    this.readEmitter.emit();
    this.close();
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/kitchen/components/alerts-dialog/alerts-dialog.component.ts